// extracted by mini-css-extract-plugin
export default {"column":"SignInbyMail_column__3hMLo","wrapper":"SignInbyMail_wrapper__km+P0","text":"SignInbyMail_text__5t4PO"};